import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({
})
export default class AlertBox extends Vue {

  @Prop({default: true})
  private showCloseBut!: boolean;

  mounted(): void {
    document.body.classList.add('modal-open');
  }

  beforeUnmount(): void {
    document.body.classList.remove('modal-open');
  }
  
}
